// extracted by mini-css-extract-plugin
module.exports = {"page":"ImportSpendingsPage_page__FyNtC","flex":"ImportSpendingsPage_flex__1tbDc"};